var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 450,
    viewBox: "0 0 1728 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-41 33L88 60L216 87L345 37L473 100L602 82L730 78L859 87V0H730H602H473H345H216H88H-41V33Z",
    fill: "#2F8DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 64L88 96L216 145L345 109L473 132L602 114L730 154L859 118V85L730 76L602 80L473 98L345 35L216 85L88 58L-41 31V64Z",
    fill: "#66A9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42 208L87 289L215 249L344 186L472 199L601 177L729 325L858 204V116L729 152L601 112L472 130L344 107L215 143L87 94L-42 62V208Z",
    fill: "#95C5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 321L88 361L216 307L345 226L473 285L602 294L730 379L859 253V202L730 323L602 175L473 197L345 184L216 247L88 287L-41 206V321Z",
    fill: "#C5DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41 451H88H216H345H473H602H730H859V251L730 377L602 292L473 283L345 224L216 305L88 359L-41 319V451Z",
    fill: "#F6F9FB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_110_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1758 33L1629 60L1501 87L1372 37L1244 100L1115 82L987 78L858 87V0H987H1115H1244H1372H1501H1629H1758V33Z",
    fill: "#2F8DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758 64L1629 96L1501 145L1372 109L1244 132L1115 114L987 154L858 118V85L987 76L1115 80L1244 98L1372 35L1501 85L1629 58L1758 31V64Z",
    fill: "#66A9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758 208L1629 289L1501 249L1372 186L1244 199L1115 177L987 325L858 204V116L987 152L1115 112L1244 130L1372 107L1501 143L1629 94L1758 62V208Z",
    fill: "#95C5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758 321L1629 361L1501 307L1372 226L1244 285L1115 294L987 379L858 253V202L987 323L1115 175L1244 197L1372 184L1501 247L1629 287L1758 206V321Z",
    fill: "#C5DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758 451H1629H1501H1372H1244H1115H987H858V251L987 377L1115 292L1244 283L1372 224L1501 305L1629 359L1758 319V451Z",
    fill: "#F6F9FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 450,
    fill: "white",
    transform: "translate(-41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_110_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 450,
    fill: "white",
    transform: "matrix(-1 0 0 1 1758 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSeparator);
export default __webpack_public_path__ + "static/media/header_separator.5c80b128d75fef1de58ffa48482f1145.svg";
export { ForwardRef as ReactComponent };